export default __webpack_public_path__ + "static/media/samuquinha.a67fa751.png";